"use client"

import { useState, useEffect } from "react"
import { Container, Row, Col, Button } from "react-bootstrap"
import {ArrowRight, Home, Info} from "lucide-react"
import { FaTools, FaShoppingCart } from "react-icons/fa";

import "./ProviderSelection.css"
import { useNavigate, useLocation } from "react-router-dom"
import IntroCarousel from "./IntroCarousel"
import BackButton from "../BackButton/BackButton";
import {translateToEnglish} from "../../utils/translations";
import InfoModal from "./InfoModal";

const ProviderSelection = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { state } = location
    const categoryType = state?.categoryType

    const [showIntro, setShowIntro] = useState(true)
    const [isModalOpen, setIsModalOpen] = useState(false) // Estado para controlar el modal

    // Funciones para controlar el modal
    const openModal = () => setIsModalOpen(true)
    const closeModal = () => setIsModalOpen(false)

    // Funciones de navegación para las tarjetas
    const navigateToServices = () => navigate("/registro/servicios", { state: { providerType: "service"}})
    const navigateToProducts = () => navigate("/registro/productos", { state: { providerType: "products"}})

    useEffect(() => {
        if (categoryType && !showIntro) {
            if (categoryType === "service" || translateToEnglish(categoryType) === "service") {
                navigate("/registro/servicios")
            } else if (categoryType === "products" || translateToEnglish(categoryType) === "products") {
                navigate("/registro/productos")
            }
        }
    }, [categoryType, showIntro, navigate])

    const handleIntroComplete = () => {
        setShowIntro(false)
    }

    if (showIntro) {
        return (
            <Container fluid className="provider-selection min-vh-100 py-5">
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={8}>
                        <IntroCarousel onComplete={handleIntroComplete} providerType={categoryType} />
                    </Col>
                </Row>
            </Container>
        )
    }

    if (categoryType) {
        return null // This will be redirected in the useEffect
    }

    return (
        <Container fluid className="provider-selection min-vh-100 py-5">
            <BackButton />

            {/* Botón de previsualización mejorado */}
            <button
                className="info-modal-float-btn"
                onClick={openModal}
                aria-label="Ver previsualización de perfil"
            >
                <Info size={20}/>
                <span>Previsualización de Perfil</span>
            </button>

            {/* Modal de vista previa */}
            <InfoModal isOpen={isModalOpen} onClose={closeModal}/>
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                    <h1 className="text-center mb-5" style={{fontFamily:"Montserrat", fontWeight:"600"}}>¿QUÉ TENÉS PARA OFRECER?</h1>

                    <Row className="provider-cards">
                        {/* Service Provider Column */}
                        <Col xs={12} sm={6} className="mb-4">
                            <div
                                className="provider-card service-provider clickable-card"
                                onClick={navigateToServices}
                            >
                                <div className="card-header-mobile">
                                    <div className="icon-wrapper service-icon">
                                        <FaTools size={32} />
                                    </div>
                                    <h2 style={{fontFamily:"Montserrat", fontWeight:"600"}}>Servicios</h2>
                                </div>
                                <p>
                                    Ofrecé tus servicios y habilidades a una amplia audiencia. Ideal para profesionales y técnicos de
                                    varios rubros ¡Permití que te encuentren y contacten fácilmente!
                                </p>
                                <Button variant="danger" className="w-100">
                                    <span className="button-text">Continuar</span>
                                    <ArrowRight className="ms-2" size={20} />
                                </Button>
                            </div>
                        </Col>

                        {/* Product Provider Column */}
                        <Col xs={12} sm={6} className="mb-4">
                            <div
                                className="provider-card product-provider clickable-card"
                                onClick={navigateToProducts}
                            >
                                <div className="card-header-mobile">
                                    <div className="icon-wrapper product-icon">
                                        <FaShoppingCart size={32} />
                                    </div>
                                    <h2 style={{fontFamily:"Montserrat", fontWeight:"600"}}>Productos</h2>
                                </div>
                                <p>
                                    Publicá tu comercio y llegá a más clientes. Mostrá lo que hacés y aumentá tu visibilidad en la
                                    plataforma. Ideal para comercios, emprendimientos y marcas.
                                </p>
                                <Button variant="primary" className="w-100" style={{flex: 0, backgroundColor: '#0056b3', borderColor: '#0056b3'}}>
                                    <span className="button-text">Continuar</span>
                                    <ArrowRight className="ms-2" size={20} />
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Back to Home Button */}
                    <div className="text-center mt-4">
                        <Button variant="secondary" style={{color:"#999"}} onClick={() => navigate("/")}>
                            <Home size={20} className="me-2" />
                            Volver al Inicio
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ProviderSelection
